<template>
  <div>
    <!--
    <div class="pull-right">
      <div class="dropdown">
        <button class="btn btn-primary dropdown-toggle sq" type="button" data-toggle="dropdown">
          Add service
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu dropdown-right">
          <li v-for="(s, i) in allServices" @click="addService(s)"><a>{{ s.code }} - {{ s.name }}</a></li>
        </ul>
      </div>
    </div>
    -->
    <loader :title="'Loading services'" v-if="loading"></loader>
    <div id="preferences-outer" class="clearfix">
      <div :class="preferenceClasses"  v-for="(item, i) in orderedServices">
        <div class="a-preference clearfix">
          <section class="pref-title-action">
            <div class="title">
              <h4>{{ item.code }} - {{ item.name }}</h4>
              <span v-if="allowDelete" class="action-delete pull-right" @click="del(i)">
                <i class="fa fa-times fa-2x"></i>
              </span>
            </div>
            <div class="clearfix pref-form-els">
              <div class="col-xs-12 col-md-6">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label class="form-label">From {{ asteriskOrBlank }}</label>
                    <auto-complete
                      :dataset="locationSearchResults"
                      :placeHolder="'Type to search'"
                      :initVal="item.fromLocation"
                      v-on:changing="data => locationText = data"
                      :fnFormatText="locationFormat"
                      :fnSelectValue="locationFormat"
                      v-on:selection-made="loc => updateFrom(item, loc)"
                    ></auto-complete>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="form-group">
                    <label class="form-label">To {{ asteriskOrBlank }}</label>
                    <auto-complete
                      :dataset="locationSearchResults"
                      :placeHolder="'Type to search'"
                      :initVal="item.toLocation"
                      v-on:changing="data => locationText = data"
                      :fnFormatText="locationFormat"
                      :fnSelectValue="locationFormat"
                      v-on:selection-made="loc => updateTo(item, loc)"
                    ></auto-complete>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="form-group">
                    <label class="form-label">Provider</label>
                    <auto-complete
                      :dataset="partySearchResults"
                      :placeHolder="'Type to search'"
                      :initVal="item.provider"
                      v-on:changing="data => partyText = data"
                      :fnFormatText="displayParty"
                      :fnSelectValue="displayParty"
                      v-on:selection-made="p => updateProvider(item, p)"
                    ></auto-complete>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label class="form-label">Amount {{ asteriskOrBlank }}</label>
                    <input class="form-control" placeholder="Enter rate if desired" type="number" v-model="item.Amount"/>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="currency" class="form-label">Currency {{ asteriskOrBlank }}</label>
                    <select class="form-control" id="currency" v-model="item.Currency">
                      <option v-for="(cur, i) in currencies" :value="cur" :selected="cur.id === item.Currency.id">{{ cur.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="note" class="form-label">Note</label>
                    <input class="form-control" type="text" v-model="item.note"/>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="col-xs-12 col-md-6" v-if="allowAdd">
        <div class="blank-outer">
          <div class="blank-pref" @click="adding = true">
            <div>
              <i v-if="!adding" class="fa fa-plus oversized"></i>
              <div v-if="adding" class="restricted">
                <h2>Select a Service</h2>
                <div class="input-group">
                  <select class="form-control" v-model="serviceSelector">
                    <option v-for="(s, i) in allServices" :value="s">{{ s.code }} - {{ s.name }}</option>
                  </select>
                  <div class="input-group-btn">
                    <button class="btn btn-primary sq" @click.stop="addService(serviceSelector)">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  <div class="input-group-btn">
                    <button class="btn btn-danger sq" @click="back">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Loader from '../../helpers/Loader.vue'
  import API from '../../../api/endpoints'
  import event from '../../../event'
  import AutoComplete from '../../helpers/AutoComplete'
  import IEHackMixin from '../../helpers/IEHackMixin'
  import FieldValue from '../../../mixins/FieldValue'
  export default {
    name: 'Preferences',
    mixins: [IEHackMixin, FieldValue],
    props: {
      preferenceClasses: {
        type: String,
        required: false,
        default: 'col-xs-12 col-md-6'
      },
      jobTypeId: {
        type: Number,
        required: false
      },
      displayParty: {
        type: Function,
        required: true
      },
      allowAdd: {
        type: Boolean,
        required: false,
        default: true
      },
      allowDelete: {
        type: Boolean,
        required: false,
        default: true
      },
      loadOnMount: {
        type: Boolean,
        required: false,
        default: true
      },
      useProvidedServices: {
        type: Boolean,
        required: false,
        default: false
      },
      providedServices: {
        type: Array,
        required: false,
        default: null
      }
    },
    components: {
      AutoComplete,
      Loader
    },
    data () {
      return {
        adding: false,
        serviceSelector: null,
        locationSearchResults: [],
        partySearchResults: [],
        loading: true,
        services: [],
        locationText: '',
        partyText: ''
      }
    },
    watch: {
      jobTypeId (newVal, oldVal) {
        if (newVal) {
          this.getServices()
        }
      },
      locationText (newVal, oldVal) {
        if (newVal.trim().length > 1) {
          this.updateLocationSearchResults(newVal)
        } else {
          this.locationSearchResults = []
        }
      },
      partyText (newVal, oldVal) {
        if (newVal.trim().length > 1) {
          this.updatePartySearchResults(newVal)
        } else {
          this.partySearchResults = []
        }
      },
      services: {
        deep: true,
        handler: function (newVal, oldVal) {
          this.$store.dispatch('quote/preferencesChange', newVal)
        }
      },
      providedServices: {
        deep: true,
        handler: function (newVal, oldVal) {
          this.checkIfPreferencesAreValid(newVal)
        }
      }
    },
    computed: {
      allServices () {
        return this.$store.getters['quote/allServices']
      },
      currencies () {
        return this.$store.getters['systemOption/currencies']
      },
      orderedServices () {
        const services = this.useProvidedServices ? [ ...this.providedServices ] : this.services
        return services.sort((a, b) => a.sequenceNumber > b.sequenceNumber)
      },
      partyGroups () {
        return this.$store.getters['authentication/userPartyGroups'] || []
      },
      userBrand () {
        return this.$store.getters['authentication/userBrand']
      },
      isRateFiller () {
        return this.providedServices
      },
      asteriskOrBlank () {
        return this.isRateFiller ? '*' : ''
      }
    },
    methods: {
      locationFormat (location) {
        let str = ''
        if (location.name) {
          str += location.name
        }
        if (location.subdivision) {
          str += `, ${location.subdivision}`
        }
        if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
          str += `, ${location.country.code}`
        }
        return str
      },
      updateFrom (item, loc) {
        item.fromLocation = loc
        this.locationSearch = ''
        this.locationSearchResults = []
      },
      updateTo (item, loc) {
        item.toLocation = loc
        this.locationSearch = ''
        this.locationSearchResults = []
      },
      updateProvider (item, p) {
        item.provider = p
        this.partyText = ''
        this.partySearchResults = []
      },
      addService (s) {
        if (s) {
          this.services.push(Object.assign({}, s, { fromLocation: '', toLocation: '', Amount: '', provider: '', Currency: '', note: '' }))
          this.adding = false
          this.serviceSelector = null
        }
      },
      back (e) {
        e.stopPropagation()
        this.adding = false
      },
      del (index) {
        this.services.splice(index, 1)
      },
      getServices () {
        this.loading = true
        this.$http.get(API.GET_ENTITIES('job-type-service'), {
          params: { jobType: parseInt(this.jobTypeId) },
          headers: { 'X-Lazy-Fetch': '0' }
        })
          .then(({data}) => {
            if (data) {
              this.services = data.map(({serviceType}) => {
                return Object.assign({}, serviceType, { fromLocation: '', toLocation: '', Amount: '', provider: '', Currency: '', note: '' })
              })
            } else {
              this.services = []
            }
          }).catch((err) => {
            console.log(err)
            event.$emit('toast', { message: err.message, type: 'warning' })
            this.services = []
          }).then(() => {
            this.loading = false
          })
      },
      updateLocationSearchResults (str) {
        this.$http.get(API.GET_LOCATIONS_NAME_LIKE(str))
          .then(({data}) => {
            if (str === this.locationText) {
              this.$store.dispatch('quote/mapLocationsWithCountry', data)
              .then(res => {
                this.locationSearchResults = res
              })
              .catch(err => {
                console.log(err)
                this.locationSearchResults = data
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      updatePartySearchResults (str) {
        let params = {
          name: str,
          category: 'SP',
          partyGroups: JSON.stringify(this.partyGroups.map(({id}) => id))
        }
        if (this.userBrand) {
          params.brand = this.userBrand
        }
        this.$http.get(API.GET_PARTIES, { params })
          .then(({data}) => {
            if (str === this.partyText) {
              this.partySearchResults = data
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      isValid (item) {
        return !this.isBlank(item.fromLocation) && !this.isBlank(item.toLocation) && !this.isBlank(item.Amount) && !this.isBlank(item.Currency)
      },
      checkIfPreferencesAreValid (services) {
        services.forEach(service => {
          if (this.isValid(service)) {
            this.$emit('toggle-save-button', true)
          } else {
            this.$emit('toggle-save-button', false)
          }
        })
      }
    },
    mounted () {
      if (this.jobTypeId && this.loadOnMount) {
        this.getServices()
      } else {
        this.loading = false
      }
      if (this.allowAdd) {
        this.$store.dispatch('quote/loadJobServiceTypes')
      }
    }
  }
</script>
<style>
  .prefs.table-responsive {
    padding: 10px;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    transition: box-shadow 0.5s;
  }
  .prefs.table-responsive:hover{
    -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  }
  .input-tr td {
    padding: 0 !important;
    height: 37px;
  }
  .input-tr .is-input {
    height: 100%;
    width: 100%;
    border: none;
    padding-left: 4px;
  }
  .a-preference {
    background-color: #eee;
    color: #fff;
    margin: 10px 0;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    transition: box-shadow 0.5s;
  }
  .a-preference h4 {
    display: inline;
  }
  .a-preference:hover {
    -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  }
  .action-delete {
    margin-top: -5px;
  }
  .pref-form-els {
    background-color: #fff;
    color: #444;
    padding: 20px 0;
  }
  .pref-form-els input {
    background: none;
    color: #444 !important;
  }
  .pref-form-els select {
    background: none;
    color: #444 !important;
  }
  .pref-form-els option {
    color: #000 !important;
  }
  .in-bl {
    display: inline-block;
  }
  .dropdown-right {
    right: 0 !important;
    left: auto !important;
  }
  .blank-pref {
    display: flex;
    align-items:center;
    justify-content: center;
    border: 1px solid #fff;
    height: 100%;
    color: #fff;
  }
  .blank-pref select {
    background: none;
    color: #fff;
  }
  .blank-pref option {
    color: #444;
  }
  .blank-pref .btn {
    border: 1px solid #fff;
    color: #fff;
    background: none;
  }
  .blank-outer {
    height: 323px;
    background: #949292;
    transition: background 0.5s;
    margin: 10px 0;
    cursor: pointer;
    padding: 10px;
  }
  .blank-outer:hover {
    background: rgba(68, 68, 68, 0.9);
  }
  .restricted {
    width: 90%;
    margin: auto;
  }
  .oversized {
    font-size: 100px;
    color: #fff;
  }

  @media only screen and (max-width : 480px) {
    .pref-form-els .col-xs-12 {
      padding: 0px;
    }
  }
  .title {
    background: #3c8dbc;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/quote/components/Preferences.vue